import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const bezugAnalyseReducer = (state = {
    bezugAnalyseData: null,
    bezugKpi: null,
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case 'RECEIVE_BezugsAnalyse_bezugAnalyseReducer':
            return { ...state, bezugAnalyseData: action.value, isLoaded: true };
        case 'RECEIVE_BezugsKpi_bezugAnalyseReducer':
            return { ...state, bezugKpi: action.value };
        case requestTypes.requestStartType.type:
            return { ...state, bezugAnalyseData: null, isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default bezugAnalyseReducer;
